import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';

import ReviewsPhotos from './ReviewsPhotos';

export default function FeaturedReview({ reviewCount, sentence, photographs }) {
  return (
    <div
      className="FeaturedReview flex items-center justify-between gap-12 md:gap-16 secondary lh-title br3 bg-gray-100 ba b--gray-200"
      style={{ padding: '10px 12px' }}
    >
      <div>
        <p className="font-14">“{sentence}”</p>
        <p className="flex items-center gap-6 mt1">
          <Icon name="fetch-review" height="16px" width="16px" />
          <span className="font-12">
            {reviewCount} owner {reviewCount === 1 ? 'review' : 'reviews'}
          </span>
        </p>
      </div>
      <ReviewsPhotos photographs={photographs} />
    </div>
  );
}

FeaturedReview.propTypes = {
  reviewCount: PropTypes.number.isRequired,
  sentence: PropTypes.string.isRequired,
  photographs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};
